import React from 'react';

import useUserHook from 'hooks/useUserHook';

import { AvailableIntegrations } from 'components/pages/IntegrationsPage/components/Integrations/components/AvailableIntegrations/AvailableIntegrations';
import { ConnectedIntegrations } from 'components/pages/IntegrationsPage/components/Integrations/components/ConnectedIntegrations/ConnectedIntegrations';

import classes from './Integrations.module.scss';

// Currently available integrations are only related to Oracle Primavera Cloud,
// so we are checking if opcEnabled is enabled for the user before showing the section.
export const Integrations = () => {
    const { opcEnabled } = useUserHook();
    return (
        <div className={classes.Integrations}>{opcEnabled ? <ConnectedIntegrations /> : <AvailableIntegrations />}</div>
    );
};
